import { useEffect, useMemo } from 'react';
import analytics from '../../analytics/analytics';
import { mapManager } from './googleMapManager';
export const handleCatctError = error => {
  analytics.logError({
    loggedFrom: 'useGoogleMapsHooks',
    message: 'Failed to initialize google maps',
    error: error === null || error === void 0 ? void 0 : error.message
  });
};
export const useGoogleMapsHooks = ({
  hotelPinsOnMap,
  locationPinsOnMap
}) => {
  // Memoize the keys to prevent unnecessary rerenders
  const hotelPinKeys = useMemo(() => Object.keys(hotelPinsOnMap), [hotelPinsOnMap]);
  const locationPinKeys = useMemo(() => Object.keys(locationPinsOnMap), [locationPinsOnMap]);
  useEffect(() => {
    if (hotelPinKeys.length !== 0 || locationPinKeys.length !== 0) {
      mapManager.initloader();
      mapManager.setMap().then(() => {
        hotelPinKeys.forEach(key => {
          mapManager.createAdvancedMarker(hotelPinsOnMap[key]);
        });
        locationPinKeys.forEach(key => {
          mapManager.createAdvancedMarker(locationPinsOnMap[key]);
        });
        const mergedPinsMap = Object.assign(Object.assign({}, locationPinsOnMap), hotelPinsOnMap);
        mapManager.fitBoundsOnCurrentMap([...hotelPinKeys, ...locationPinKeys].map(key => mergedPinsMap[key])).catch(error => {
          analytics.logError({
            loggedFrom: 'useGoogleMapsHooks',
            message: 'Failed to call fitBoundsOnCurrentMap on mapManager',
            error: error.message
          });
        });
        mapManager.fireCallbacks();
      }).catch(handleCatctError);
    }
  }, [hotelPinKeys.length, locationPinKeys.length]);
};